module.exports = __webpack_public_path__ + "static/cheif-information-a330e0ed9721b8253fbbdc4d6f4cba7d.jpg";